var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 
 * @file Utility for sidebar
 * @author Box
 */

import { hasSkills as hasSkillsData } from './Skills/skillUtils';

var SidebarUtils = function () {
    function SidebarUtils() {
        _classCallCheck(this, SidebarUtils);
    }

    _createClass(SidebarUtils, null, [{
        key: 'canHaveDetailsSidebar',

        /**
         * Determines if we can render the details sidebar.
         * Only relies on props.
         *
         * @param {ContentSidebarProps} props - User passed in props
         * @return {Boolean} true if we should render
         */
        value: function canHaveDetailsSidebar(_ref) {
            var _ref$detailsSidebarPr = _ref.detailsSidebarProps,
                detailsSidebarProps = _ref$detailsSidebarPr === undefined ? {} : _ref$detailsSidebarPr;
            var hasProperties = detailsSidebarProps.hasProperties,
                hasAccessStats = detailsSidebarProps.hasAccessStats,
                hasClassification = detailsSidebarProps.hasClassification,
                hasVersions = detailsSidebarProps.hasVersions,
                hasNotices = detailsSidebarProps.hasNotices;

            return !!hasProperties || !!hasAccessStats || !!hasClassification || !!hasVersions || !!hasNotices;
        }

        /**
         * Determines if we can render the metadata sidebar.
         * Only relies on props.
         *
         * @param {ContentSidebarProps} props - User passed in props
         * @return {Boolean} true if we should render
         */

    }, {
        key: 'canHaveMetadataSidebar',
        value: function canHaveMetadataSidebar(props) {
            return !!props.hasMetadata;
        }

        /**
         * Determines if we can render the activity sidebar.
         * Only relies on props.
         *
         * @param {ContentSidebarProps} props - User passed in props
         * @return {Boolean} true if we should render
         */

    }, {
        key: 'canHaveActivitySidebar',
        value: function canHaveActivitySidebar(props) {
            return !!props.hasActivityFeed;
        }

        /**
         * Determines if we can render the skills sidebar.
         * Only relies on props.
         *
         * @param {ContentSidebarProps} props - User passed in props
         * @return {Boolean} true if we should render
         */

    }, {
        key: 'canHaveSkillsSidebar',
        value: function canHaveSkillsSidebar(props) {
            return !!props.hasSkills;
        }

        /**
         * Determines if we can render the sidebar.
         * Only relies on props.
         *
         * @param {ContentSidebarProps} props - User passed in props
         * @return {Boolean} true if we should have a sidebar
         */

    }, {
        key: 'canHaveSidebar',
        value: function canHaveSidebar(props) {
            return SidebarUtils.canHaveDetailsSidebar(props) || SidebarUtils.canHaveActivitySidebar(props) || SidebarUtils.canHaveSkillsSidebar(props) || SidebarUtils.canHaveMetadataSidebar(props);
        }

        /**
         * Determines if we should bother rendering the skills sidebar.
         * Relies on props and file data.
         *
         * @private
         * @param {ContentSidebarProps} props - User passed in props
         * @param {BoxItem} file - box file
         * @return {Boolean} true if we should render
         */

    }, {
        key: 'shouldRenderSkillsSidebar',
        value: function shouldRenderSkillsSidebar(props, file) {
            return !!file && !!props.hasSkills && hasSkillsData(file);
        }

        /**
         * Determines if we should bother rendering the sidebar.
         * Relies on props and file data.
         *
         * @param {ContentSidebarProps} props - User passed in props
         * @param {BoxItem} file - box file
         * @return {Boolean} true if we should fetch or render
         */

    }, {
        key: 'shouldRenderSidebar',
        value: function shouldRenderSidebar(props, file) {
            return !!file && (SidebarUtils.canHaveDetailsSidebar(props) || SidebarUtils.shouldRenderSkillsSidebar(props, file) || SidebarUtils.canHaveActivitySidebar(props) || SidebarUtils.canHaveMetadataSidebar(props));
        }
    }]);

    return SidebarUtils;
}();

export default SidebarUtils;